import { Provider } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MatDateFormats } from '@angular/material/core';

import { TypedDateAdapter } from './typed-date-adapter';

/**
 * Canonical MM/DD/YYYY display format for date inputs (EFF-23638). The `parse.dateInput` slot is
 * left `null` because {@link TypedDateAdapter} performs format-agnostic parsing of typed input.
 */
export const TYPED_DATE_FORMATS: MatDateFormats = {
	parse: {
		dateInput: null,
	},
	display: {
		dateInput: { year: 'numeric', month: '2-digit', day: '2-digit' },
		monthYearLabel: { year: 'numeric', month: 'short' },
		dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
		monthYearA11yLabel: { year: 'numeric', month: 'long' },
	},
};

/**
 * Registers {@link TypedDateAdapter} and the canonical MM/DD/YYYY formats as the application-wide
 * Material date adapter, replacing `provideNativeDateAdapter()`.
 */
export function provideTypedDateAdapter(): Provider[] {
	return [
		{ provide: DateAdapter, useClass: TypedDateAdapter },
		{ provide: MAT_DATE_FORMATS, useValue: TYPED_DATE_FORMATS },
	];
}
